import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationRateVariationArgs } from 'src/types/backend';

const MUTATION = gql`
  mutation RateVariation($id: ID!, $rating: Int!, $feedback: String) {
    rateVariation(id: $id, rating: $rating, feedback: $feedback)
  }
`;

type Variables = BackendMutationRateVariationArgs;

export const rateVariation = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<string>(result.data);
};
